import { render, staticRenderFns } from "./reserve-item.vue?vue&type=template&id=cf8474e4&scoped=true&"
import script from "./reserve-item.vue?vue&type=script&lang=js&"
export * from "./reserve-item.vue?vue&type=script&lang=js&"
import style0 from "./reserve-item.vue?vue&type=style&index=0&id=cf8474e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8474e4",
  null
  
)

export default component.exports